import { createAction, props, createReducer, on } from '@ngrx/store';
import { HubDropReducer } from '../models/hubdrop.interface';

// Action creators using createAction
export const updateLocationType = createAction(
  '[HubDrop] Update Location Type',
  props<{ payload: any }>()
);

export const updateSelectedPostOffice = createAction(
  '[HubDrop] Update Selected Post Office',
  props<{ payload: any }>()
);

export const setZoneId = createAction(
  '[HubDrop] Set Zone ID',
  props<{ payload: any }>()
);

export const refreshHubDrop = createAction(
  '[HubDrop] Refresh Hub Drop',
  props<{ payload: any }>()
);

export const resetHubDropReducer = createAction(
  '[HubDrop] Reset Hub Drop Reducer'
);

// Initial state
const initState: HubDropReducer = {
  selectedCollectionType: null,
  selectedPostOffice: null,
  zoneId: null,
};

// Reducer using createReducer and on
export const hubDropReducer = createReducer(
  initState,
  on(updateLocationType, (state, { payload }) => ({
    ...state,
    selectedCollectionType: payload,
  })),
  on(updateSelectedPostOffice, (state, { payload }) => ({
    ...state,
    selectedPostOffice: payload,
  })),
  on(setZoneId, (state, { payload }) => ({
    ...state,
    zoneId: payload,
  })),
  on(refreshHubDrop, (state, { payload }) => ({
    ...payload,
  })),
  on(resetHubDropReducer, () => ({
    ...initState,
  }))
);
